import React from 'react';
import { getAdditionalPage } from '../../../services';
import AdditionalPage from '@/containers/AdditionalPage';
import Layout from '@/components/Layout';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import { fetchAdditionalPageSeoDetails } from 'src/utils/fetchAdditionalPageSeoDetails';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';
import { getRoute, PATH } from 'src/utils/routes';
import { checkIfPageTypeBlog } from 'src/utils/checkIfPageTypeBlog';
import { getServerSideRedirectionData } from 'src/utils/getServerSideRedirectionData';

const AdditionalPageContainer = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  const advCustomSeo = props.advCustomSeoDetails;

  return (
    <Layout
      store={storeInfo}
      title={
        advCustomSeo?.title?.value ||
        `${props?._addPage?.page_name} - ${storeInfo?.store_info?.name}`
      }
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        advCustomSeo?.description ||
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGTitle={advCustomSeo?.og_title?.value || null}
      OGDescription={advCustomSeo?.og_description || null}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      canonicalTagUrl={`${storeInfo?.store_url}/p/${props?._addPage?.slug_url}`}
      {...props}
    >
      <AdditionalPage {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  const { slug, template_id, preview } = ctx.query;
  let propData = {
    catalogCategories: [],
    catalogTags: [],
    _addPage: null,
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: [
      'collections',
      'categories',
      'advancedSeo',
      'additionalPagesList',
    ],
  });

  if (propType?.ssrStore?.storeReducer?.store?.store_id) {
    const _addpageResponse = await getAdditionalPage(
      slug,
      propType.ssrStore.storeReducer.store.store_id,
      Boolean(Number(preview)),
      template_id
    );

    if (_addpageResponse.data && _addpageResponse.data.status) {
      propData._addPage = JSON.parse(JSON.stringify(_addpageResponse.data.page)) || null;

      const isBlogPage = checkIfPageTypeBlog(propData._addPage?.page_type);

      if (isBlogPage) {
        const domainFromStore = propType?.ssrStore?.storeReducer?.store?.domain;
        return getServerSideRedirectionData(getRoute(PATH.BLOG, domainFromStore, ctx));
      }

      // fetch advance seo data after fetching additional page data
      const storeInfo = propType.ssrStore.storeReducer.store;
      propType.advCustomSeoDetails = await fetchAdditionalPageSeoDetails({
        type: 'additional_page',
        typeId: propData?._addPage?.page_id,
        storeInfo,
      });
    } else {
      ctx.res.writeHead(302, { location: '/404' });
      ctx.res.end();
    }
  }

  propData = { ...propData, ...(propType || {}) };
  const extraProps = getRequiredCtxProps(ctx, propType);

  return { props: { ...propData, ...extraProps } };
}
export default AdditionalPageContainer;
